import { NgModule } from '@angular/core';
import { cartBaseTranslationChunksConfig, cartBaseTranslationsEn } from '@spartacus/cart/base/assets';
import {
  ADD_TO_CART_FEATURE,
  CartBaseRootModule,
  CART_BASE_FEATURE,
  MINI_CART_FEATURE,
} from '@spartacus/cart/base/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { CartNumberModule } from './base/components/cart-number/cart-number.module';
import { CustomExportOrderEntriesModule } from './import-export/components/export-entries';
import { DeliveryCostModule } from './base/components/delivery-cost/delivery-cost.module';
import { CartPoLineModule } from './base/components/cart-po-line/cart-po-line.module';
import { ProductAllowedQuantityModule } from './base/components/product-allowed-quantity/product-allowed-quantity.module';
import { CartEmptyModule } from './base/components/cart-empty/cart-empty.module';

@NgModule({
  declarations: [],
  imports: [
    CartBaseRootModule,
    CartNumberModule,
    DeliveryCostModule,
    CustomExportOrderEntriesModule,
    CartPoLineModule,
    CartEmptyModule,
    ProductAllowedQuantityModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_BASE_FEATURE]: {
          module: () => import('./base/cart-base.module').then(m => m.CustomCartBaseModule),
        },
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [MINI_CART_FEATURE]: {
          module: () => import('./base/components/mini-cart/mini-cart.module').then(m => m.CustomMiniCartModule),
        },
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [ADD_TO_CART_FEATURE]: {
          module: () => import('../product/add-to-cart/add-to-cart.module').then(m => m.CustomAddToCartModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: cartBaseTranslationsEn },
        chunks: cartBaseTranslationChunksConfig,
      },
    }),
  ],
})
export class CartBaseFeatureModule {}
